import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { ProductService } from '../_services';
import * as productActions from '../_actions/product';

@Injectable({
  providedIn: 'root',
})
export class ProductEffects {
  loadproducts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(productActions.loadProducts),
      mergeMap(() =>
        this.productService.getProducts().pipe(
          map((products) => productActions.loadProductsSuccess({ products })),
          catchError((error) => of(productActions.loadProductsFailure({ error })))
        )
      )
    )
  );

  addproduct$ = createEffect(() =>
    this.actions$.pipe(
      ofType(productActions.addProduct),
      mergeMap(({ product }) =>
        this.productService.saveProduct(product).pipe(
          map((savedproduct) => productActions.addProductSuccess({ product: savedproduct })),
          catchError((error) => of(productActions.addProductFailure({ error })))
        )
      )
    )
  );

  updateproduct$ = createEffect(() =>
    this.actions$.pipe(
      ofType(productActions.updateProduct),
      mergeMap(({ product }) =>
        this.productService.saveProduct(product).pipe(
          map((updatedproduct) => productActions.updateProductSuccess({ product: updatedproduct })),
          catchError((error) => of(productActions.updateProductFailure({ error })))
        )
      )
    )
  );

  deleteproduct$ = createEffect(() =>
    this.actions$.pipe(
      ofType(productActions.deleteProduct),
      mergeMap(({ id }) =>
        this.productService.deleteProduct(id).pipe(
          map(() => productActions.deleteProductSuccess({ id })),
          catchError((error) => of(productActions.deleteProductFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private productService: ProductService
  ) {}
}
